import React from 'react';
import SymbolSearch from './SymbolSearch.js';
import SymbolCategory from './SymbolCategory.js';


class DesignerSymbolSelect extends React.Component {

    constructor(props) {
        super(props);

        const symbolSearchList = [];
        for (var catI = 0; catI < this.props.symbolCategories.length; catI++) {
            let symbolSelects = null;
            if (this.props.symbolCategories[catI] !== null && this.props.symbolCategories[catI].symbols !== undefined) {
    
                symbolSelects = [];
    
                for (var si = 0; si < this.props.symbolCategories[catI].symbols.length; si++) {
    
                    var symbol = this.props.symbolCategories[catI].symbols[si];
                    let isBlacklisted = false;
                    if (symbol.blacklist !== undefined)
                    {
                        for (var bli = 0; bli < symbol.blacklist.length; bli++) {
                            if (symbol.blacklist[bli].type == 'perspectiv' && symbol.blacklist[bli].object == this.props.activePerspective.id)
                            {
                                isBlacklisted = true;
                                break;
                            }
                        }
                    }
    
                    if (!isBlacklisted)
                    {
                        symbolSearchList.push(symbol);
                    }
                }
            }
        }


        this.state = {
            searchParam: '',
            symbolSearchList: symbolSearchList
        }

        this.handleSymbolSelect = this.handleSymbolSelect.bind(this);
        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    }

    handleSymbolSelect(symbol) {
        this.props.onSymbolSelect(symbol);
    }

    handleSearchInputChange(searchParam) {
        this.setState({
            searchParam: searchParam
        });
    }

    render() {

        if (this.props.symbolCategories.length == 0)
            return null;

        const symbolCategories = this.props.symbolCategories.map((symbolCategory) =>
            <SymbolCategory 
                key={symbolCategory.title} 
                activePerspective={this.props.activePerspective}
                activeDesignerVariants={this.props.activeDesignerVariants}
                symbolCategory={symbolCategory}
                searchParam={this.state.searchParam}
                onSymbolSelect={this.handleSymbolSelect} 
            />
        );

        return (
            <div className="designer_symbol_select designer_controll row">
                <div className="designer_controll_title col-sm-2 col-md-1">
                    <span>Symbole:</span>
                </div>
                <div className="designer_controll_actions col-sm-10 col-md-11">
                    <div className="col-xs-12 nopadding-mobile">
                        <SymbolSearch
                            searchParam={this.state.searchParam}
                            symbolSearchList={this.state.symbolSearchList}
                            onSearchInputChange={this.handleSearchInputChange}
                        />
                        <div className="symbol_categories">
                            {symbolCategories}
                        </div>
                    </div>
                </div>
                <div style={{ clear: 'left' }} />
            </div>
        );
    }
}

export default DesignerSymbolSelect;



// WEBPACK FOOTER //
// ./src/DesignerSymbolSelect.js